import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ children, ...rest }) => {
  const { auth } = useSelector((state) => state);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return auth?.ok ? (
          React.cloneElement(children, { auth })
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
